import React from 'react'
import { BsExclamationCircleFill } from 'react-icons/bs'
import {motion} from "framer-motion"

const ErrorMessage = ({message}) => {
if(message){
    return <p className="text-red-500 text-xs mt-1 flex items-center gap-1.5">
       <motion.div
      animate={{
        x: [-2, 2, -2, 0], // Déplacement horizontal
      }}
      transition={{
        repeat: Infinity,
        duration: 2, // L'animation dure 2 secondes
        ease: "easeInOut",
        times: [0, 0.25, 0.5, 1], // Synchronisation des étapes du mouvement
        repeatDelay: 6, // Pause de 3 secondes après chaque cycle
      }}
    >
      <BsExclamationCircleFill className="text-red-500" />
    </motion.div>{message}</p>
}else{
    return null   
}  
}

export default ErrorMessage